<template>
  <div class="container">
    <div class="row">
      <!-- Formulaire d'ajout de dossier -->
      <div v-if="showFileUploadForm" class="file-upload-form" @click="closePopup">
        <div class="file-upload-form-content download" @click.stop>
          <a class="close-button" @click="closePopup">&times;</a>
          <h2>Ajouter un dossier</h2>         
        
          <form @submit.prevent="submit">
            <input id="texte" type="text" v-model="dossier" placeholder="Nom du dossier" required>
            <button type="submit">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-plus" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9.81a2 2 0 0 0 1.991-1.819l.637-7c.124-.684-.295-1.335-.956-1.56L10.5 3a.5.5 0 0 0-.5-.5h-3.672a.5.5 0 0 0-.354.146L5.828 2.5H2.5a.5.5 0 0 0-.5.5z"/>
                <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>
              </svg>
              Créer le dossier
            </button>
          </form>

          <div v-if="successFichierArticle" class="alert alert-success" role="alert">
            {{ successFichierArticle }}
          </div>
          <div v-if="errorFichierArticle" class="alert alert-danger" role="alert">
            {{ errorFichierArticle }}
          </div>
        </div>
      </div>

      <div v-if="showFileViewer" class="file-upload-form" @click="closePopup">
        <div class="file-upload-form-content" @click.stop>
          <a class="close-button" @click="closePopup">&times;</a>
          <!-- Afficher le fichier ici, par exemple, dans une iframe pour les fichiers PDF -->
          <iframe v-if="extFile == 'pdf'" :src="linkFile" width="100%" height="500"></iframe>
          <img v-if="extFile == 'jpeg' || extFile == 'jpg' || extFile == 'png' || extFile == 'webp'" :src="linkFile" alt="Image"/>
          <div v-if="extFile == 'igs' || extFile == 'prt' || extFile == 'vcf' || extFile == 'step' || extFile == 'stp' || extFile == 'STEP'">
            <iframe :src="`//sharecad.org/cadframe/load?url=${linkFile}`" scrolling="no"></iframe>
            <div class="download-btn-wrapper">
              <a @click.prevent="downloadCurrentFile" class="btn-download-file" href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
                Télécharger le fichier
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="listDocs encart">
          <h2>Arborescence des fichiers</h2>
          <div v-if="errorDelete" class="alert alert-danger" role="alert">
            {{ errorDelete }}
          </div>
          <div v-if="successDelete" class="alert alert-success" role="alert">
            {{ successDelete }}
          </div>
          <div v-if="successFichierArticle" class="alert alert-success" role="alert">
            {{ successFichierArticle }}
          </div>
          <div v-if="errorFichierArticle" class="alert alert-danger" role="alert">
            {{ errorFichierArticle }}
          </div>
          
          <!-- Zone de dépôt racine -->
          <div 
            v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be'"
            class="drop-zone root-drop-zone"
            :class="{ 'drag-over': isDragOverRoot }"
            @drop="handleDrop($event, '/simef/espace-client/espaces-articles/' + codeArticle)"
            @dragover="handleDragOver"
            @dragenter="handleDragEnter($event, 'root')"
            @dragleave="handleDragLeave($event, 'root')"
            @click="triggerFileInput('root')"
            style="cursor: pointer;"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-upload" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-3.746 1.996 3.686 3.686 0 0 0 .180 6.741A1.5 1.5 0 0 1 6 11.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-.956-1.996 2.686 2.686 0 0 1-.004-5.162z"/>
              <path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
            </svg> Glissez ou <span class="file-label">cliquez ici</span> pour les ajouter à la racine
            <input
              type="file"
              ref="fileInputRoot"
              multiple
              style="display: none"
              @change="addFichiers($event, '/simef/espace-client/espaces-articles/' + codeArticle)"
            />
          </div>

          <ul>
            <li v-for="item in arborescence" :key="item.path">
              <div v-if="item.type === 'dossier'" class="headArbo">
                <input v-if="item.path && (loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be')" type="checkbox" id="selec" name="selec" @change="toggleDeletePath(item.path)" :checked="deletePaths.includes(item.path)" /> 
                <div @click="toggleOpen(item)" class="folder-header">
                  <svg v-if="item.type === 'dossier'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-fill" viewBox="0 0 16 16">
                    <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                  </svg>
                  {{ item.name }}
                </div>
                <!-- Zone de dépôt pour le dossier -->
                
              </div>
             
              <div v-else class="headArbo">
                <input v-if="item.path && (loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be')" type="checkbox" id="selec" name="selec"  @change="toggleDeletePath(item.path)" :checked="deletePaths.includes(item.path)"/> 
                <a @click.stop="openFilePopup(item)" class="linkArbo">{{ item.name }}</a>
              </div>
              <!-- Si l'élément est un dossier et a des enfants, récursivement afficher les enfants -->
              <ul v-if="item.type === 'dossier' && item.isOpen">
                <TreeItemArticles 
                  :getFichiers="getFichiers" 
                  :toggleDeletePath="toggleDeletePath" 
                  :arborescence="item.children" 
                  :deletePaths="this.deletePaths" 
                  :level="level + 1"
                  :loggedInRole="loggedInRole"
                  :handleDrop="handleDrop"
                  :handleDragOver="handleDragOver"
                  :handleDragEnter="handleDragEnter"
                  :handleDragLeave="handleDragLeave"
                  :dragOverFolder="dragOverFolder"
                  :openFilePopup="openFilePopup"
                  :addElement="addElement"
                ></TreeItemArticles>
                 <div 
                  v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be'"
                  class="drop-zone folder-drop-zone"
                  :class="{ 'drag-over': dragOverFolder === item.path }"
                  @drop="handleDrop($event, item.path)"
                  @dragover="handleDragOver"
                  @dragenter="handleDragEnter($event, item.path)"
                  @dragleave="handleDragLeave($event, item.path)"
                  @click="triggerFileInput(item.path)"
                  style="cursor: pointer;"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-upload" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-3.746 1.996 3.686 3.686 0 0 0 .180 6.741A1.5 1.5 0 0 1 6 11.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-.956-1.996 2.686 2.686 0 0 1-.004-5.162z"/>
                    <path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
                  </svg> Déposer ou <span class="file-label">cliquez ici</span> pour ajouter un fichier
                  <input
                    type="file"
                    :ref="'fileInput_' + item.path"
                    multiple
                    style="display: none"
                    @change="addFichiers($event, item.path)"
                  />
                </div>
                <a v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be'" @click="addElement(item.path)" class="linkArbo addElement" href="#" :style="{ marginLeft: 30 + 'px' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-plus" viewBox="0 0 16 16">
                    <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9.81a2 2 0 0 0 1.991-1.819l.637-7c.124-.684-.295-1.335-.956-1.56L10.5 3a.5.5 0 0 0-.5-.5h-3.672a.5.5 0 0 0-.354.146L5.828 2.5H2.5a.5.5 0 0 0-.5.5z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>
                  </svg>
                  Ajouter un dossier
                </a>
              </ul>
            </li>
          </ul>
          <a v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be'" @click="addElement('/simef/espace-client/espaces-articles/' + codeArticle)" class="linkArbo addElement addElementParent" href="#" >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-plus" viewBox="0 0 16 16">
              <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9.81a2 2 0 0 0 1.991-1.819l.637-7c.124-.684-.295-1.335-.956-1.56L10.5 3a.5.5 0 0 0-.5-.5h-3.672a.5.5 0 0 0-.354.146L5.828 2.5H2.5a.5.5 0 0 0-.5.5z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>
            </svg>
            Ajouter un dossier
          </a>
          <button v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='be'" @click="deleteElement()" class="deleteElement">- Supprimer</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Loader -->
  <div v-if="isLoading" class="loader">
    <div id="loading"></div>
  </div>
</template>

<script>
import TreeItemArticles from './TreeItem.vue'; // Importez le composant TreeItem
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'
import { processFile, downloadFile } from '@/mixins/imageCompressionMixin.js'

export default {
  components: {
    TreeItemArticles,
  },
  data() {
    return {
      showFileUploadForm: false,
      showFileViewer: false,
      codeArticle: '',
      fichiers: [],
      fichiersListe: [],
      confirmationMessage: '',
      loggedInRole: null,
      errorMessage: '',
      successFichierArticle: '',
      errorFichierArticle: '',
      errorDelete: '',
      successDelete: '',
      arborescence: [],
      level: 0,
      path: '',
      linkFile: '',
      extFile: '',
      dossier: "",
      deletePaths: [],
      isLoading: false,
      isDragOverRoot: false,
      dragOverFolder: null,
    }
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;
    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }
    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }
  

  },
  mounted() { 
    


    this.getFichiers();
    
    
  }, 
  computed: {

  },
  methods: {
    handleDragOver(event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    },
    
    handleDragEnter(event, target) {
      event.preventDefault();
      if (target === 'root') {
        this.isDragOverRoot = true;
      } else {
        this.dragOverFolder = target;
      }
    },
    
    handleDragLeave(event, target) {
      event.preventDefault();
      // Vérifier si on quitte vraiment la zone (pas un enfant)
      if (!event.currentTarget.contains(event.relatedTarget)) {
        if (target === 'root') {
          this.isDragOverRoot = false;
        } else {
          this.dragOverFolder = null;
        }
      }
    },
    
    handleDrop(event, targetPath) {
      event.preventDefault();
      this.isDragOverRoot = false;
      this.dragOverFolder = null;
      
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.uploadFiles(files, targetPath);
      }
    },
    
    async uploadFiles(files, targetPath) {
      this.isLoading = true;
      const formData = new FormData();
      
      // Traiter et compresser les fichiers si nécessaire
      for (let i = 0; i < files.length; i++) {
        const processedFile = await processFile(files[i]);
        formData.append('fichiers[]', processedFile);
      }
      
      formData.append('path', targetPath);
      formData.append('dossier', ''); // Pas de nouveau dossier, juste upload de fichiers
      
      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiersArbo.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })
      .then(response => {
        this.successFichierArticle = response.data.successFichierArticle;
        this.errorFichierArticle = response.data.errorFichierArticle;
        this.getFichiers();
        
        // Clear messages after 3 seconds
        setTimeout(() => {
          this.successFichierArticle = '';
          this.errorFichierArticle = '';
        }, 3000);
      })
      .catch(error => {
        console.error(error);
        this.errorFichierArticle = "Une erreur est survenue lors de l'upload";
        setTimeout(() => {
          this.errorFichierArticle = '';
        }, 3000);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    submit() {
      // Création de dossier uniquement
      const formData = new FormData();
      
      // Pas de fichiers, seulement le dossier
      formData.append('path', this.path);
      formData.append('dossier', this.dossier);

      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/ajoutFichiersArbo.php', formData)
      .then(response => {
        this.successFichierArticle = response.data.successFichierArticle;
        this.errorFichierArticle = response.data.errorFichierArticle;
        this.dossier = ""; // Reset le nom du dossier
        this.getFichiers();
        
        // Fermer la popup après succès
        if (response.data.successFichierArticle) {
          setTimeout(() => {
            this.showFileUploadForm = false;
            this.successFichierArticle = '';
          }, 1500);
        }
      })
      .catch(error => {
        console.error(error);
        this.errorFichierArticle = "Une erreur est survenue lors de la création du dossier";
      });
    },
    addFichiers(event, targetPath) {
      const files = event.target.files;
      if (files.length > 0) {
        this.uploadFiles(files, targetPath);
      }
    },
    triggerFileInput(targetPath) {
      if (targetPath === 'root') {
        this.$refs.fileInputRoot.click();
      } else {
        const refName = 'fileInput_' + targetPath;
        const input = this.$refs[refName];
        if (input) {
          (Array.isArray(input) ? input[0] : input).click();
        }
      }
    },
    getFichiers() {
      this.isLoading = true; // Show loader
      axios.post('https://www.simef.fr/espace-client/api/arborescence.php', {
        article: this.codeArticle,
      })
      .then(response => {
          this.arborescence = response.data;
      })
      .catch(error => {
          console.error(error);
      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },

    deleteElement() {
      this.isLoading = true; // Show loader
      console.log(this.deletePaths);
      const confirmation = window.confirm('Êtes-vous sûr de vouloir supprimer cette liaison ?');

      if (confirmation) {
        axios.post('https://www.simef.fr/espace-client/api/supprFichiersArbo.php', {
          deletePaths: this.deletePaths,
        })
        .then(response => {
          this.successDelete = response.data.successDelete;
          this.errorDelete = response.data.errorDelete;
          this.getFichiers();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false; // Hide loader
        });
      }
    },
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    },
    toggleOpen(item) {
      item.isOpen = !item.isOpen;
    },
    addElement(item) {
      this.path = item;
      this.dossier = ""; // Reset le champ
      this.showFileUploadForm = true;
    },
    closePopup(event) {
      event.stopPropagation();
      this.showFileUploadForm = false;
      this.showFileViewer = false;
    },
    openFilePopup(item) {
      const supportedExtensions = ['pdf', 'jpeg', 'jpg', 'png', 'webp', 'igs', 'prt', 'vcf', 'step', 'stp', 'STEP'];
      const ext = item.extension ? item.extension.toLowerCase() : '';
      const fileUrl = item.path.replace("/simef", "https://www.simef.fr");
      if (!supportedExtensions.map(e => e.toLowerCase()).includes(ext)) {
        downloadFile(fileUrl, item.name || item.path.split('/').pop());
        return;
      }
      this.showFileViewer = true;
      this.linkFile = fileUrl;
      this.extFile = item.extension;
    },
    downloadCurrentFile() {
      downloadFile(this.linkFile, this.linkFile.split('/').pop());
    },

    toggleDeletePath(path) {
      if (this.deletePaths.includes(path)) {
        // Si le chemin est déjà présent, le retirer du tableau
        const index = this.deletePaths.indexOf(path);
        this.deletePaths.splice(index, 1);
      } else {
        // Si le chemin n'est pas présent, l'ajouter au tableau
        this.deletePaths.push(path);
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$primary: #2b358d;
.listeFichiers {
  ul {
    list-style: none;
    text-align: left;
    padding: 0px;
    li {
  
      a {
        background: $primary;
        margin-bottom: 5px;
        color: #fff;
        padding: 4px 10px;
        font-size: 0.9rem;
        display: flex;
        flex-direction: column;
      }
    }
  }
  .liste3D {
    iframe {
      min-height: 450px;
      .canvas {
        div:nth-child(3) {
          height: 100%;
        }
      }

    }
  }

  .plans {
    cursor: pointer;
  }

  .togglePdf {
    min-height: 500px;
  }
}
.listDocs {
  margin-bottom: 100px;
  ul {
    margin-bottom: 5px;
    li {
      margin-bottom: 0px;
    }
  }
}
.headArbo {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  
  .folder-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    
    svg {
      margin-right: 5px;
    }
  }
}
.linkArbo {
  background: none!important;
  padding: 0px!important;
  color: $primary!important;
  text-decoration: underline!important;
  font-size: 1rem!important;
}
.addElement {
  font-weight: 900;
  font-size: 0.9rem!important;
  display: flex;
  align-items: center;
  gap: 5px;
  
  svg {
    margin-right: 3px;
  }
}
.addElementParent {
  display: flex;
  text-align: left;
}
.file-upload-form {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  .file-upload-form-content {
    position: relative;
    background-color: #fff;
    border-radius: 0px;
    img, iframe {
      max-height: 90vh;
    }
    iframe {
      width: 100%;
      height: 60vh;
    }
    h2 {
      text-align: center!important;
    }
  }
  .download {
    padding: 40px;
  }
}
.close-button {
  font-size: 30px;
}
.deleteElement {
  background: $primary;

  color: #fff;
  padding: 4px 12px;
  display: inline-block;
  margin-top: 5px;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
}

.download-btn-wrapper {
  display: flex;
  justify-content: center;
  padding: 12px 0 4px;
}

.btn-download-file {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: $primary;
  color: #fff !important;
  padding: 8px 18px;
  border-radius: 4px;
  text-decoration: none !important;
  font-size: 0.9rem;
  cursor: pointer;
  
  &:hover {
    opacity: 0.85;
  }
}

.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 10px;
  margin: 5px 0;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &.drag-over {
    border-color: $primary;
    background-color: rgba($primary, 0.1);
    
    svg {
      color: $primary;
    }
  }
  
  svg {
    margin-right: 5px;
    color: #666;
  }
  
  span {
    font-size: 0.9rem;
    color: #666;
  }
}

.root-drop-zone {
 display: inline-block;
  padding: 5px 8px;
  margin-left: 10px;
  border: 1.5px dashed #a3a3a3;
    border-radius: 10px;
    font-size: 0.9rem;
    margin-left: 32px;
       width: 60%!important;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    gap: 4px;
    
  
}

.folder-drop-zone {
  display: inline-block;
  padding: 5px 8px;
  margin-left: 10px;
  border: 1.5px dashed #a3a3a3;
    border-radius: 10px;
    font-size: 0.9rem;
    margin-left: 32px;
      width: 60%!important;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    gap: 4px;
  svg {
    margin-right: 3px;
  }
  
  span {
    font-size: 0.7rem;
  }
}

.headArbo {
  display: flex;
  align-items: center;
  gap: 10px;
  
  .folder-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    
    svg {
      margin-right: 5px;
    }
  }
}
</style>